import React from "react";
import { ShieldCheck, Award, Wrench } from "lucide-react";

export default function TrustBar() {
  return (
    <section
      className="relative py-10 sm:py-12 border-y border-white/5 bg-[#080808]"
      data-testid="trust-bar"
      aria-label="Partnerek és tanúsítványok"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div
          className="text-center mb-8"
          data-testid="trust-bar-eyebrow"
        >
          <span
            className="inline-flex items-center gap-3 text-[0.7rem] font-bold uppercase tracking-[0.32em] text-zinc-500"
            style={{ fontFamily: "Barlow Condensed" }}
          >
            <span className="m-stripe h-[2px] w-10" />
            Bizalom &amp; tanúsítványok
            <span className="m-stripe h-[2px] w-10" />
          </span>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-px bg-white/5 border border-white/5">
          {/* Q-Service — official partner logo */}
          <a
            href="https://www.q-service.hu/q-service-szerviz-halozat/autoservis/139/build--service-kft/"
            target="_blank"
            rel="noopener noreferrer"
            className="bg-[#0e0e0e] hover:bg-[#141414] transition-colors p-6 sm:p-8 flex flex-col items-center justify-center gap-3 group"
            data-testid="trust-q-service"
            aria-label="Q-Service hálózati tag — hivatalos profil megtekintése"
          >
            <img
              src="/assets/q-service-logo.png"
              alt="Q-Service hálózati tag"
              className="h-10 sm:h-12 w-auto object-contain group-hover:scale-105 transition-transform"
              loading="lazy"
            />
            <span
              className="text-[0.65rem] font-bold uppercase tracking-[0.24em] text-zinc-400"
              style={{ fontFamily: "Barlow Condensed" }}
            >
              Hálózati tag
            </span>
          </a>

          {/* MotulEVO badge */}
          <div
            className="bg-[#0e0e0e] hover:bg-[#141414] transition-colors p-6 sm:p-8 flex flex-col items-center justify-center gap-3 group"
            data-testid="trust-motul-evo"
          >
            <div
              className="px-5 py-2.5 border-2 border-[#E1132C] bg-black"
              style={{
                fontFamily: "Barlow Condensed",
                boxShadow: "0 0 24px rgba(225,19,44,0.18)",
              }}
            >
              <span className="text-2xl sm:text-3xl font-black uppercase tracking-tight text-white">
                Motul<span className="text-[#E1132C]">EVO</span>
              </span>
            </div>
            <span
              className="text-[0.65rem] font-bold uppercase tracking-[0.24em] text-zinc-400"
              style={{ fontFamily: "Barlow Condensed" }}
            >
              Hivatalos technológia
            </span>
          </div>

          {/* Trust facts */}
          <div
            className="bg-[#0e0e0e] hover:bg-[#141414] transition-colors p-6 sm:p-8 flex flex-col sm:flex-row items-center justify-center gap-5 sm:gap-6"
            data-testid="trust-facts"
          >
            <Fact
              icon={Award}
              value="32"
              label="Év tapasztalat"
            />
            <span className="hidden sm:block w-px h-8 bg-white/10" />
            <Fact
              icon={Wrench}
              value="5000+"
              label="Javított autó"
            />
            <span className="hidden sm:block w-px h-8 bg-white/10" />
            <Fact
              icon={ShieldCheck}
              value="100%"
              label="Garancia"
            />
          </div>
        </div>
      </div>
    </section>
  );
}

function Fact({ icon: Icon, value, label }) {
  return (
    <div className="flex items-center gap-3">
      <Icon className="w-5 h-5 text-[#0082D2] shrink-0" strokeWidth={1.6} />
      <div className="leading-tight">
        <div
          className="text-xl sm:text-2xl font-black text-white"
          style={{ fontFamily: "Barlow Condensed" }}
        >
          {value}
        </div>
        <div
          className="text-[0.6rem] font-bold uppercase tracking-[0.18em] text-zinc-500"
          style={{ fontFamily: "Barlow Condensed" }}
        >
          {label}
        </div>
      </div>
    </div>
  );
}
